<template>
  <div>
    <div class="disbursement__single outer-container">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Add Money to
            <span>your wallet</span>
          </div>
        </div>
        <div class="panel__content panel__content--grey panel__content--heavy-padded">
          <!--fund wallet-->
          <form action class="form disburse-form" @submit.prevent="walletToFund()">
            <!--funding source, never mind my classes says disburse - copy and paste ish-->
            <div class="form__item">
              <label for="disburseSource" class="form__label--span form--left">
                Add
                <span>from</span>
              </label>
              <div class="select form--right">
                <select
                  name="funding-source"
                  id="disburseSource"
                  class="select__input"
                  v-model="fundingObject.source"
                  v-on:change="setFundingInputs(); clearError()"
                  v-validate="'required'"
                >
                  <option value="null">Select a Funding Method</option>
                  <option value="voucher">Voucher Code</option>
                  <!-- <option value="e_bills">E-Bills</option> -->
                  <option value="linked_card">Linked Cards</option>
                  <option value="bank_account">Transfer to Bank Account</option>
                  <!--<option value="wallet">Transfer from another currency</option>-->
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                    <path
                      fill-rule="evenodd"
                      d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('funding-source')">
                <p>{{ errors.first('funding-source') }}</p>
              </div>
            </transition>

            <!--funding destination-->
            <div class="form__item" v-if="provideDestination">
              <label for="fundingDestination" class="form__label--span form--left">
                <span>Destination</span>
              </label>
              <div class="select form--right">
                <select
                  name="destination"
                  id="fundingDestination"
                  class="select__input"
                  v-model="fundingObject.destination"
                  v-on:change="walletCurrencyCode(); clearError()"
                  v-validate="'required'"
                >
                  <option
                    v-for="currency in walletList"
                    v-bind:value="currency.currencyId"
                  >{{currency.name.toUpperCase()}} - {{ currency.currencyCode }} {{currency.currencyBalance}}</option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                    <path
                      fill-rule="evenodd"
                      d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('destination')">
                <p>{{ errors.first('destination') }}</p>
              </div>
            </transition>

            <!--if wallet is selected as funding source-->
            <div class="form__item" v-if="provideSourceWallet">
              <label for="fundingSource" class="form__label--span form--left">
                Select
                <span>currency source</span>
              </label>
              <div class="select form--right">
                <select
                  name="currency-source"
                  id="fundingSource"
                  class="select__input"
                  v-model="fundingObject.walletAsSource"
                  v-validate="!provideSourceWallet ? '' : 'required'"
                >
                  <option
                    v-for="currency in walletList"
                    v-bind:value="currency.currencyId"
                  >{{currency.name.toUpperCase()}} - {{ currency.currencyCode }} {{currency.currencyBalance}}</option>
                </select>
                <div class="select__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10">
                    <path
                      fill-rule="evenodd"
                      d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('currency-source')">
                <p>{{ errors.first('currency-source') }}</p>
              </div>
            </transition>

            <div class="form__item" v-if="!provideDestination" id="bank_transfer">
            </div>

            <!--funding amount-->
            <div class="form__item" v-show="provideAmount">
              <label for="fundingAmount" class="form__label--span form--left">
                <span>Amount</span>
              </label>
              <div class="form--right input-conjoined">
                <input
                  type="text"
                  class="form__input"
                  :disabled="true"
                  readonly
                  v-model="currencyResult"
                >
                <input
                  type="text"
                  name="amount"
                  class="form__input"
                  :class="{'input': true, 'is-danger': errors.has('email') }"
                  placeholder
                  id="fundingAmount"
                  v-model="fundingObject.amount"
                  v-validate="!provideAmount ? '' : 'required|numeric'"
                >
              </div>
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('amount')">
                <p>{{ errors.first('amount') }}</p>
              </div>
            </transition>


            <!--phone number-->
            <!-- <div class="form__item" v-show="!phoneNumberExists && !provideAmount ">
              <label for="countryCode" class="form__label--span form--left">Phone<span>number</span></label>
              <div class="form--right input-conjoined">
                <div class="select">
                  <select name="country-code" id="countryCode" class="select__input" v-model="countryCode">
                    <option value="+234">+234</option>
                    <option value="+01">+01</option>
                    <option value="+02">+02</option>
                    <option value="+03">+03</option>
                  </select>
                  <div class="select__icon icon__black">
                    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
                  </div>
                </div>
                <input type="text" name="phonenumber" class="form__input" placeholder="" id="phoneNumber" v-model="fundingObject.phoneNumber"
                       v-validate="!phoneNumberExists && provideAmount ? '' : 'required|numeric|min:10|max:10'">
              </div>
            </div>-->
            <!--if error exists-->
            <!-- <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('phonenumber')">
                <p>{{ errors.first('phonenumber') }}</p>
              </div>
            </transition>-->

            <!--voucher input-->
            <div>
              <div class="form__item" v-if="provideVoucher">
                <label for="voucherCode" class="form__label--span form--left">
                  Voucher
                  <span>code</span>
                </label>
                <div class="form--right">
                  <input
                    type="text"
                    name="voucher-code"
                    class="form__input"
                    placeholder
                    id="voucherCode"
                    v-model="fundingObject.voucherCode"
                    v-validate="!provideVoucher ? '' : 'required'"
                  >
                </div>
              </div>
              <!--if error exists-->
              <transition name="slide-fade">
                <div class="form__input--error--text" v-if="errors.has('voucher-code')">
                  <p>{{ errors.first('voucher-code') }}</p>
                </div>
              </transition>
            </div>

            <div class="form__item" v-if="provideSourceWallet">
              <label for="walletPassword" class="form__label--span form--left">
                Wallet
                <span>password</span>
              </label>
              <input
                type="password"
                name="password"
                class="form__input"
                id="walletPassword"
                v-model="fundingObject.walletPassword"
                v-validate="!provideSourceWallet ? '' : 'required'"
              >
            </div>
            <!--if error exists-->
            <transition name="slide-fade">
              <div class="form__input--error--text" v-if="errors.has('password')">
                <p>{{ errors.first('password') }}</p>
              </div>
            </transition>

            <div class="form__item disburse-form__submit" v-if="provideDestination && enableActions">
              <button
                id="fundWallet"
                class="btn btn--primary btn--block"
                :disabled="errors.any()"
                type="submit"
              >ADD MONEY</button>
            </div>
          </form>

          <!--funding amount-->
            <div class="card" style="width: 50%; margin: auto; height: 150px" v-show="useBankTransfer">
              <div>
                <ul class="">
                  <li><p>Log-in to your Mobile / Internet Banking portal or USSD</p></li>
                  <li><p>Transfer the amount you wish to fund to the details below</p></li>
                  <li><p>Account Number : <b>{{ accountNumber }}</b></p></li>
                  <li><p>Bank Name: <b> {{ bank }} </b></p></li>
                  <li><p>Transfered Funds will be credited to your balance.</p></li>
                </ul>
              </div>
            </div>


        </div>
      </div>
    </div>
    <!--modals-->
    <modal-template v-if="transactionDone">
      <div slot="header" class="display__inline-block">
        <div class="modal__title">
          Wallet
          <span>Funding</span>
        </div>
      </div>
      <div
        slot="action-button"
        class="modal-default-button display__inline-block"
        @close="transactionDone = false"
      >
        <button class="btn btn--default" data-dismis="modal"
                  aria-label="Close" @click="utilityMethods().triggerPageRefresh()">Back</button>
      </div>

      <div slot="body">
        <div class="disburse__result text-center">
          <transition name="slide-fade">
            <div v-if="transactionSuccess">
              <!--success icon-->
              <div class="result-img">
                <svg
                  class="icon icon--custom-big"
                  enable-background="new 0 0 50 50"
                  version="1.1"
                  viewBox="0 0 50 50"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                  <polyline
                    points="38 15 22 33 12 25"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  ></polyline>
                </svg>
              </div>
              <p class="disburse__result__success success-text">Wallet funded successfully!</p>
              <button
                class="btn btn--primary"
                @click="utilityMethods().triggerPageLoad()"
              >See funding history</button>
            </div>
          </transition>
          <transition name="slide-fade">
            <div v-if="transactionFailure">
              <div class="result-img">
                <svg
                  enable-background="new 0 0 50 50"
                  version="1.1"
                  viewBox="0 0 50 50"
                  xml:space="preserve"
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon--custom-big"
                >
                  <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                  <polyline
                    points="16 34 25 25 34 16"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  ></polyline>
                  <polyline
                    points="16 16 25 25 34 34"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-miterlimit="10"
                    stroke-width="2"
                  ></polyline>
                </svg>
              </div>
              <p
                v-for="error in transactionErrors"
                class="disburse__result__error error-text"
              >{{error}}</p>
              <button
                class="btn btn--primary"
                @click="utilityMethods().triggerPageRefresh()"
              >Retry funding</button>
              <button
                class="btn btn--default"
                @click="utilityMethods().triggerPageLoad()"
              >See funding history</button>
            </div>
          </transition>
        </div>
      </div>
    </modal-template>
  </div>
</template>

<script>
import { fundWalletWithVoucher, fundWalletWithRave, fundWalletWithLinkedCard, fundWalletWithWallet } from "../../utils/wallet-transactions/fundWalletService";
import { getSingleUser } from "../../utils/user/getUserDetails";
import ModalTemplate from "@/components/partials/ModalTemplate.vue";

export default {
  created() {
    this.checkPhoneNumber();
    this.accountNo();
    console.log(this.checkPhoneNumber());
  },

  data() {
    return {
      countryCode: "+234",
      showModal: false,
      walletCurrencyList: null,
      provideSourceWallet: false,
      provideAmount: false,
      useBankTransfer: false,
      provideVoucher: false,
      provideDestination: true,
      fundingObject: {
        source: "null",
        destination: "",
        amount: "",
        phoneNumber: "",
        voucherCode: "",
        firstName: this.$cookies.get("userFirstName"),
        lastName:
          this.$cookies.get("userLastName") === null || this.$cookies.get("userLastName") === ''
            ? this.$cookies.get("userFirstName")
            : this.$cookies.get("userLastName"),
        email: lthis.$cookies.get("userEmail"),
        redirectUrl: "https://moneywave.flutterwave.com",
        walletAsSource: "",
        walletPassword: ""
      },
      accountNumber: "",
      bank: "",
      currencyResult: "",
      transactionErrors: [],
      transactionDone: false,
      transactionFailure: false,
      transactionSuccess: false,
      phoneNumberExists: false
    };
  },
  components: {
    "modal-template": ModalTemplate
  },
  methods: {
    //clear all errors on form if select changes
    clearError() {
      this.errors.clear();
    },

    //set forms to show depending on selected funding source
    setFundingInputs() {
      this.provideAmount = false;
      this.provideSourceWallet = false;
      this.provideVoucher = false;
      this.useBankTransfer = false;

      if (this.provideDestination == false) document.getElementById('bank_transfer').innerHTML = '';
      this.provideDestination = true;

      if (this.fundingObject.source === "voucher") {
        this.provideVoucher = true;
      } else if (this.fundingObject.source === "linked_card") {
        this.provideAmount = true;
      } else if (this.fundingObject.source === "bank_account") {
        this.provideDestination = false;
        this.useBankTransfer = true;
      }
    },
    //fund wallet with voucher

    fundWithVoucher() {
      let voucherPayload = {
        source: this.fundingObject.source,
        code: this.fundingObject.voucherCode
      };

      //Call the voucher API
      let app = this;

      fundWalletWithVoucher(voucherPayload, this.fundingObject.destination)
        .then(response => {
          console.log(response);
          if (response.status === 200) {
            let newB = response.data.data.newBalance;
            this.utilityMethods().transactionSuccessful();
            this.updateWallet(newB);
          }
        })
        .catch(error => {
          this.$Progress.fail();
          this.utilityMethods().transactionFailed(error.response.data.message);
          console.log(this.transactionErrors);
        });
    },

    //fund wallet with Linked card
    fundWithLinkedCard() {
      let linkedCardPayload = {
        amount: this.fundingObject.amount,
        source: this.fundingObject.source,
        firstName: this.fundingObject.firstName,
        lastName: this.fundingObject.lastName,
        email: this.fundingObject.email,
        phoneNumber: (this.fundingObject.phoneNumber.includes('+234')) ? this.fundingObject.phoneNumber : this.countryCode + this.fundingObject.phoneNumber,
        redirectUrl: "https://localhost:8080/overview"
      };
      console.log(linkedCardPayload);

      //Call the linkedcard API
      this.$Progress.start();
      let app = this;
      fundWalletWithLinkedCard(
        linkedCardPayload,
        this.fundingObject.destination
      )
        .then(response => {
          console.log(response);
          if (response.data.status === 200) {
            this.$Progress.finish();
            this.utilityMethods().transactionSuccessful();
            this.updateWallet(linkedCardPayload.amount);
          }
        })
        .catch(error => {
          this.$Progress.fail();
          this.utilityMethods().transactionFailed(error.response.data.message);
          console.log(this.transactionErrors);
        });
    },

    //fund wallet with Rave
    fundWithRave() {
      let ravePayload = {
        amount: this.fundingObject.amount,
        source: this.fundingObject.source,
        firstName: this.fundingObject.firstName,
        lastName: this.fundingObject.lastName,
        email: this.fundingObject.email,
        phoneNumber: this.countryCode + this.fundingObject.phoneNumber,
        redirectUrl: "https://localhost:8080/overview"
      };

      //Call the rave API
      let app = this;
      this.$Progress.start();
      fundWalletWithRave(ravePayload, this.fundingObject.destination)
        .then(response => {
          console.log(response);
          //            if(response.data.status === 'success'){
          //              window.open(response.data.data.authurl);
          //              this.fundingSuccess = true;
          //              this.errorExists = false;
          //              this.errors = [];
          //              this.success = 'funding succcessful'
          //            }
          let self = this;
          let getPaidData = response.data.data;
          getPaidData.callback = function(response) {
            console.log(response);
          };
          getPaidData.onclose = function() {
            self.utilityMethods().triggerPageRefresh();
            console.log("closed");
          };
          getpaidSetup(getPaidData);
        })
        .catch(error => {
          this.errorExists = true;
          this.fundingSuccess = false;
          this.transactionErrors = [];
          this.transactionErrors.push(error.response.data.message);
          console.log(this.transactionErrors);
        });
    },

    //fund wallet with another wallet currency

    fundWithWallet() {
      let walletPayload = {
        amount: this.fundingObject.amount,
        source: this.fundingObject.source,
        uref: 0,
        password: this.fundingObject.walletPassword
      };

      //Call the wallet to wallet API
      let app = this;
      this.$Progress.start();
      fundWalletWithWallet(walletPayload, this.fundingObject.destination)
        .then(response => {
          app.fundingDone = true;
          if (response.data.status === "success") {
            this.$Progress.finish();
            this.utilityMethods().transactionFailed(
              error.response.data.message
            );
          }
        })
        .catch(error => {
          this.$Progress.fail();
          this.utilityMethods().transactionFailed(error.response.data.message);
          console.log(this.transactionErrors);
        });
    },

    walletToFund() {
      this.$validator.validateAll().then(result => {
        if (result) {
          document.getElementById("fundWallet").disabled = true;
          let fundingSource = this.fundingObject.source;
          if (fundingSource === "voucher") {
            return this.fundWithVoucher();
          } else if (fundingSource === "linked_card") {
            return this.fundWithLinkedCard();
          } else if (fundingSource === "rave") {
            return this.fundWithRave();
          } else if (fundingSource === "wallet") {
            return this.fundWithWallet();
          }
        }
      });
    },
    updateWallet(balance){
      let new_list = [];
      let a = this.walletList;
      a.filter((index, wall) => {
        if (index.currencyId == this.fundingObject.destination){
          index.currencyBalance = balance;
          new_list.push(index);
        } else {
          new_list.push(index);
        }
      });
      this.$store.commit('emptyPrimaryCurrencies');
      new_list.forEach((wallet)=>{
        this.$store.commit('updatePrimaryWalletCurrencies', {
          currencyCode: wallet.currencyCode,
          currencyId:wallet.currencyId,
          currencyBalance:wallet.currencyBalance,
          currencyUref:wallet.currencyUref,
          country: wallet.country,
          countryName: wallet.countryName,
          name: wallet.name,
          });
      });
    },

    accountNo() {
      getSingleUser(window.localStorage.getItem('merchantId'), true)
      .then((resp) => {
        console.log(resp)
        if (resp && resp.data && resp.data[0] && resp.data[0].accountNumber !== null) {
          this.accountNumber = resp.data[0].accountNumber
          this.bank = resp.data[0].bankName;
          if (resp.data[0].tag === 'hs') this.bank = 'Highstreet Microfinance Bank';
        } else {
          this.accountNumber = window.localStorage.getItem('accountNumber');
          this.bank = 'Highstreet Microfinance Bank';
        }
      })
      .catch((err) => {
        console.log(err);
      });
    },

    checkPhoneNumber() {
      if (this.$cookies.get("phoneNumber") === null) {
        this.phoneNumberExists = false;
      } else {
        this.fundingObject.phoneNumber = this.$cookies.get(
          "phoneNumber"
        );
        this.phoneNumberExists = true;
      }
    },

    //get selected wallet
    walletCurrencyCode() {
      let filterString = this.fundingObject.destination,
        walletArray = this.walletList;

      const result = walletArray.filter(
        wallet => wallet.currencyId === filterString
      );
      this.currencyResult = result[0].currencyCode;
      console.log(this.currencyResult);
    },

    utilityMethods() {
      let self = this;
      return {
        //page load methods
        triggerPageLoad() {
          self.$router.push("/wallet/balances/funding-history");
          location.reload();
        },
        triggerPageRefresh() {
          //close the modal, reset all data
          self.transactionDone = false;
          self.fundingObject.amount = "";
          self.fundingObject.destination = "";
          self.fundingObject.voucherCode = "";
          self.fundingObject.walletAsSource = "";
          self.fundingObject.walletPassword = "";
          self.transactionErrors = [];
          if (!self.phoneNumberExists) {
            self.fundingObject.phoneNumber = "";
          }
          self.transactionFailure = false;
          self.transactionSuccess = false;
          setTimeout(() => { self.clearError(); }, 100);
        },
        transactionSuccessful() {
          self.transactionDone = true;
          self.transactionSuccess = true;
          self.transactionFailure = false;
          self.transactionErrors = [];
          setTimeout(() => { self.clearError(); }, 100);
        },
        transactionFailed(error) {
          self.$Progress.fail();
          self.transactionDone = true;
          self.transactionSuccess = false;
          self.transactionFailure = true;
          setTimeout(() => { self.clearError(); }, 100);
          self.transactionErrors = [];
          self.transactionErrors.push(error);
        }
      };
    }
  },

  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
    //get wallet currency list from store.
    walletList() {
      let a = [];
      if(Object.keys(window.localStorage.getItem("walletList")).length > 0) a = JSON.parse(window.localStorage.getItem("walletList"));
      return a;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/wallet/FundWallet.vue